module.exports = __webpack_public_path__ + "img/news-nav-icon-3.57f40f8e.png";